import { useIsFeedbackEnabled } from '@ms/yammer-hooks/dist/ocps';

import { UseUIFeatureCheck } from '../types';

export const useIsUserFeedbackEnabled: UseUIFeatureCheck = () => useIsFeedbackEnabled('UserFeedbackFormEnabled');
